module.exports = __webpack_public_path__ + "media/images/icon__profile@2x-acc3711e259e7c3488f1de1a466dacd4.png";